import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService } from 'src/app/services/security.service';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';
import { SharedDirectoryService } from 'src/app/services/api/shared-directory.service';
import { SharedDirectory } from 'src/app/interfaces/shared-directory';
import { AccessDirectory } from 'src/app/interfaces/access-directory';
import { AccessDirectories } from 'src/app/interfaces/access-diretories';

@Component({
    selector: 'app-directory',
    templateUrl: './directory.component.html',
    styleUrls: ['./directory.component.scss'],
})

export class DirectoryComponent implements OnInit {

    public title: string = "Medimail Patient - Mon carnet patient";

    public errorMessage: string ;
    public errorType: string ;

    public sharedDirectory: SharedDirectory[] = [];
    public accessDirectory: AccessDirectories | undefined;

    public activeTab: string = 'directory';
    constructor(public userService: UserService,
                public route: Router,
                private activatedRoute: ActivatedRoute,
                private titleService: Title)
    {
        this.errorMessage = "";
        this.errorType = "";
        this.titleService.setTitle(this.title);
    }

    ngOnInit(): void {
        this.accessDirectory = this.activatedRoute.snapshot.data.directory[1].content;
        this.sharedDirectory = this.activatedRoute.snapshot.data.directory[0].content;
    }
}
